import * as Yup from "yup";

export const employeeSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome completo é obrigatório")
    .test("two-words", "Insira nome e sobrenome", (value) => {
      if (!value) return false;
      return value.trim().split(/\s+/).length >= 2;
    }),

  email: Yup.string().required("E-mail é obrigatório").email("E-mail inválido"),

  password: Yup.string()
    .min(6, "A senha deve ter no mínimo 6 caracteres")
    .nullable(),

  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password")], "As senhas não coincidem")
    .nullable(),

  role_id: Yup.string().required("Função é obrigatória"),

  show_in_schedule_and_site: Yup.boolean(),
  can_view_all_schedules: Yup.boolean(),

  phone_whatsapp: Yup.string().nullable(),
  cep: Yup.string().nullable(),
  address: Yup.string().nullable(),
  address_number: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  country: Yup.string().nullable(),
});

export const employeeCreateSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome completo é obrigatório")
    .test("two-words", "Insira nome e sobrenome", (value) => {
      if (!value) return false; // Já é tratado pelo required, mas previne erros
      return value.trim().split(/\s+/).length >= 2;
    }),

  email: Yup.string().required("E-mail é obrigatório").email("E-mail inválido"),

  password: Yup.string()
    .required("A senha é obrigatória")
    .min(6, "A senha deve ter no mínimo 6 caracteres"),

  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password")], "As senhas não coincidem")
    .required("Confirme a senha"),

  role_id: Yup.string().required("Função é obrigatória"),

  show_in_schedule_and_site: Yup.boolean(),
  can_view_all_schedules: Yup.boolean(),

  phone_whatsapp: Yup.string().nullable(),
  cep: Yup.string().nullable(),
  address: Yup.string().nullable(),
  address_number: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  country: Yup.string().nullable(),

  // is_owner: Yup.boolean()
  //   .required('Indicação de proprietário é obrigatória'),

  // cpf: Yup.string()
  //   .required('CPF é obrigatório')
  //   .matches(/^\d{11}$/, 'CPF deve conter exatamente 11 dígitos'),

  // phone_whatsapp: Yup.string()
  //   .required('Telefone WhatsApp é obrigatório')
  //   .matches(/^\d{10,15}$/, 'Telefone inválido'),

  // cep: Yup.string()
  //   .required('CEP é obrigatório')
  //   .matches(/^\d{8}$/, 'CEP deve conter exatamente 8 dígitos'),

  // country: Yup.string()
  //   .required('País é obrigatório'),

  // state: Yup.string()
  //   .required('Estado é obrigatório'),

  // city: Yup.string()
  //   .required('Cidade é obrigatória'),

  // address: Yup.string()
  //   .required('Endereço é obrigatório'),

  // address_number: Yup.string()
  //   .required('Número do endereço é obrigatório')
});

export const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .required("A senha é obrigatória")
    .min(6, "A senha deve ter no mínimo 6 caracteres"),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password")], "As senhas não coincidem")
    .required("Confirme a senha"),
});
